import React from 'react'
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import { useNavigate } from "react-router-dom";
import { FaTrashAlt } from "react-icons/fa";

import { MdCancel } from "react-icons/md";
import { FaCheck } from "react-icons/fa";

import { convertDateToString } from '../controller/control';
import { createStore } from '../store/state';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

export function CategoryData({ handleStatus, deleteCategory, category }) {
    return (
        <TableContainer component={Paper}>
            <Table sx={{ minWidth: 700 }} aria-label="customized table">
                <TableHead>
                    <TableRow>
                        <StyledTableCell>#</StyledTableCell>
                        <StyledTableCell>Photo</StyledTableCell>
                        <StyledTableCell>Name</StyledTableCell>
                        <StyledTableCell>Status</StyledTableCell>
                        <StyledTableCell>Action</StyledTableCell>
                    </TableRow>
                </TableHead>
                {category.length > 0 ? <TableBody>
                    {category.map((item, i) => (
                        <StyledTableRow key={item._id}>
                            <StyledTableCell>{i + 1}</StyledTableCell>
                            <StyledTableCell><img src={item.categImageUrl} alt={item.categoryName} className='cart-image' /></StyledTableCell>
                            <StyledTableCell component="th" scope="row">
                                {item.categoryName}
                            </StyledTableCell>
                            <StyledTableCell>
                                <label className="switch">
                                    <input
                                        checked={item.status && "checked"}
                                        type="checkbox"
                                        value={item.status}
                                        onChange={() => handleStatus(item._id)}
                                    />
                                    <span className="slider round"></span>
                                </label>
                            </StyledTableCell>
                            <StyledTableCell>
                                <div>
                                    <Button variant="contained" color="error" onClick={() => deleteCategory(item._id)}><FaTrashAlt /></Button>
                                </div>
                            </StyledTableCell>
                        </StyledTableRow>
                    ))}
                </TableBody> : <TableBody>
                    <StyledTableCell colSpan={5}>No record found</StyledTableCell>
                </TableBody>
                }
            </Table>
        </TableContainer>
    )
}

export function CouponData({ handleStatus, handleDisplay, deleteCoupon, getCoupon, coupon }) {
    return (
        <TableContainer component={Paper}>
            <Table sx={{ minWidth: 700 }} aria-label="customized table">
                <TableHead>
                    <TableRow>
                        <StyledTableCell>#</StyledTableCell>
                        <StyledTableCell>Name</StyledTableCell>
                        <StyledTableCell>Discount</StyledTableCell>
                        <StyledTableCell>Status</StyledTableCell>
                        <StyledTableCell>Display</StyledTableCell>
                        <StyledTableCell>Action</StyledTableCell>
                    </TableRow>
                </TableHead>
                {coupon.length > 0 ? <TableBody>
                    {coupon.map((item, i) => (
                        <StyledTableRow key={item._id}>
                            <StyledTableCell>{i + 1}</StyledTableCell>
                            <StyledTableCell component="th" scope="row">
                                {item.name}
                            </StyledTableCell>
                            <StyledTableCell component="th" scope="row">
                                {item.discount}%
                            </StyledTableCell>
                            <StyledTableCell>
                                <label className="switch">
                                    <input
                                        checked={item.status && "checked"}
                                        type="checkbox"
                                        value={item.status}
                                        onChange={() => handleStatus(item._id)}
                                    />
                                    <span className="slider round"></span>
                                </label>
                            </StyledTableCell>
                            <StyledTableCell>
                                <label className="switch">
                                    <input
                                        checked={item.couponShow && "checked"}
                                        type="checkbox"
                                        value={item.couponShow}
                                        onChange={() => handleDisplay(item._id)}
                                    />
                                    <span className="slider round"></span>
                                </label>
                            </StyledTableCell>
                            <StyledTableCell>
                                <div>
                                    <Button variant="contained" color="error" onClick={() => deleteCoupon(item._id)}><FaTrashAlt /></Button>
                                </div>
                            </StyledTableCell>
                        </StyledTableRow>
                    ))}
                </TableBody> : <TableBody>
                    <StyledTableCell colSpan={5}>No record found</StyledTableCell>
                </TableBody>
                }
            </Table>
        </TableContainer>
    )
}

export function OrderData({ bookingList, sortedData, handleBookingStatus }) {
    const navigate = useNavigate();
    const { user } = createStore((state) => state)
    return (
        <TableContainer component={Paper}>
            <Table aria-label="customized table">
                <TableHead>
                    <TableRow>
                        <StyledTableCell>SI</StyledTableCell>
                        <StyledTableCell >Name</StyledTableCell>
                        <StyledTableCell >Photo</StyledTableCell>
                        <StyledTableCell >Price</StyledTableCell>
                        <StyledTableCell >Appointment Detail</StyledTableCell>
                        <StyledTableCell >{user?.isAdmin ? "Action" : "Status"}</StyledTableCell>
                    </TableRow>
                </TableHead>
                {bookingList.length > 0 ? user?.isAdmin ? <TableBody>
                    {sortedData.map((order, i) => <StyledTableRow key={i}>
                        <StyledTableCell >{i + 1}</StyledTableCell>
                        <StyledTableCell >{order.itemName}</StyledTableCell>
                        <StyledTableCell ><img src={order.itemImgPath} alt={order.itemName} className='cart-image' /></StyledTableCell>
                        <StyledTableCell >₹{order.itemPrice}</StyledTableCell>
                        <StyledTableCell >
                            <p>{convertDateToString(order.bookingDate)}</p>
                            <p>{order.time}</p>
                        </StyledTableCell>
                        <StyledTableCell>
                            {order.bookingStatus === "pending" ? <>
                                <Button
                                    variant="outlined"
                                    color='success'
                                    onClick={() => handleBookingStatus(order._id, "approve")}
                                >
                                    <FaCheck />
                                </Button>
                                <Button
                                    variant="outlined"
                                    color='error'
                                    onClick={() => handleBookingStatus(order._id, "reject")}
                                >
                                    <MdCancel />
                                </Button></> :
                                <>
                                    {order.bookingStatus === "pending" && <span className='stat-pending'> Pending</span>}
                                    {order.bookingStatus === "approve" && <span className='stat-approve'> Approve</span>}
                                    {order.bookingStatus === "reject" && <span className='stat-reject'> Reject</span>}
                                </>
                            }
                        </StyledTableCell>
                    </StyledTableRow>)}
                </TableBody> : <TableBody>
                    {sortedData.map((order, i) => user?._id === order.userId && <StyledTableRow key={i}>
                        <StyledTableCell >{i + 1}</StyledTableCell>
                        <StyledTableCell >{order.itemName}</StyledTableCell>
                        <StyledTableCell ><img src={order.itemImgPath} alt={order.itemName} className='cart-image' /></StyledTableCell>
                        <StyledTableCell >₹{order.itemPrice}</StyledTableCell>
                        <StyledTableCell >
                            <p>{convertDateToString(order.bookingDate)}</p>
                            <p>{order.time}</p>
                        </StyledTableCell>
                        <StyledTableCell>
                            {order.bookingStatus === "pending" && <span className='stat-pending'> Pending</span>}
                            {order.bookingStatus === "approve" && <span className='stat-approve'> Approved</span>}
                            {order.bookingStatus === "reject" && <span className='stat-reject'> Rejected</span>}
                        </StyledTableCell>
                    </StyledTableRow>)}
                </TableBody> : <TableBody>
                    <StyledTableCell colSpan={6}>
                        <div className='thank-msg'>
                            <h2>No record found</h2>
                            <Button variant="contained" onClick={() => navigate("/")}>
                                Back to home
                            </Button>
                        </div>
                    </StyledTableCell>
                </TableBody>}
            </Table>
        </TableContainer>
    )
}

export function ProductData({ handleStatus, deleteProduct, product }) {
    return (
        <TableContainer component={Paper}>
            <Table sx={{ minWidth: 700 }} aria-label="customized table">
                <TableHead>
                    <TableRow>
                        <StyledTableCell>#</StyledTableCell>
                        <StyledTableCell>Photo</StyledTableCell>
                        <StyledTableCell>Name</StyledTableCell>
                        <StyledTableCell>Fee</StyledTableCell>
                        <StyledTableCell>Status</StyledTableCell>
                        <StyledTableCell>Action</StyledTableCell>
                    </TableRow>
                </TableHead>
                {product.length > 0 ? <TableBody>
                    {product.map((item, i) => (
                        <StyledTableRow key={item._id}>
                            <StyledTableCell>{i + 1}</StyledTableCell>
                            <StyledTableCell><img src={item.productImgUrl} alt={item.title} className='cart-image' /></StyledTableCell>
                            <StyledTableCell component="th" scope="row">
                                {item.title}
                            </StyledTableCell>
                            <StyledTableCell component="th" scope="row">
                                ₹{item.price}
                            </StyledTableCell>
                            <StyledTableCell>
                                <label className="switch">
                                    <input
                                        checked={item.status && "checked"}
                                        type="checkbox"
                                        value={item.status}
                                        onChange={() => handleStatus(item._id)}
                                    />
                                    <span className="slider round"></span>
                                </label>
                            </StyledTableCell>
                            <StyledTableCell>
                                <div>
                                    <Button variant="contained" color="error" onClick={() => deleteProduct(item._id)}><FaTrashAlt /></Button>
                                </div>
                            </StyledTableCell>
                        </StyledTableRow>
                    ))}
                </TableBody> : <TableBody>
                    <StyledTableCell colSpan={5}>No record found</StyledTableCell>
                </TableBody>
                }
            </Table>
        </TableContainer>
    )
}
